import { PageController } from '@client/components/_core/layout/PageController';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { trpc } from '@client/trpc/client';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/public/new-complaint-by-key/$key')({ component: NewComplaintByKey });

function NewComplaintByKey() {
    const { key } = Route.useParams();
    const searchParams = Route.useSearch();
    const { data } = trpc.org.getOrgIdByKey.useQuery({ key });
    const navigate = useNavigate();

    useEffect(() => {
        if (!data) {
            return;
        }

        navigate({ to: '/public/$orgId/complaint/new', params: { orgId: data }, search: searchParams });
    }, [data]);

    return (
        <PageController route={Route}>
            <div className="flex flex-1 items-center justify-center">
                <div className="text-lg text-muted-foreground">Redirecting to a new complaint form...</div>
            </div>
        </PageController>
    );
}
